<template>
  <div class="box10">
    <pageTitle title="课程适合人群" />
    
    <div class="bottom">
       <img src="../../../assets/coursePage/linux/box10/img01.png"/>
      
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
};
</script>

<style lang="less" scoped>
.box10 {
background: #FFFFFF;
  padding: 60px 0 80px;

  .bottom{
    padding: 0 32px;
    margin-top: 48px;
    img{
      width: 100%;
     
    }
    
  }
}
</style>
